import React from 'react';
import AutomationProcess from '../../Containers/AutomationContainer/AutomationProcess';

const AutomationsProcess = (props) => {
	return (
		<AutomationProcess />
	);
}

export default AutomationsProcess;